import React from 'react';
import LogicoUpload from './LogicoUploadComponent';
import LogicoUploadComponent from './LogicoUploadComponent';

export default (props) => {
    return <LogicoUploadComponent location={props.location} />;
}
